import { render } from "./FloatingWidget.vue?vue&type=template&id=7771e70b&scoped=true"
import script from "./FloatingWidget.vue?vue&type=script&lang=js"
export * from "./FloatingWidget.vue?vue&type=script&lang=js"

import "./FloatingWidget.vue?vue&type=style&index=0&id=7771e70b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7771e70b"]])

export default __exports__